import React from 'react';
import styles from './KeyPeopleRequirementCard.module.scss';
import classNames from 'classnames';
import { Tooltip } from '@Components/Tooltip/Tooltip';
import { RiQuestionLine } from 'react-icons/ri';
import { useTranslation } from 'react-i18next';
import { KeyPersonRole } from '@Types/KeyPeople';

export const KeyPeopleRequirementCard = ({ ...keyPersonRole }: KeyPersonRole) => {
  const { t } = useTranslation('account');

  return (
    <div className={classNames(styles.container, keyPersonRole.amount > 0 && styles.completed)}>
      <div className={styles.titleContainer}>
        <h3 className={styles.title}>{keyPersonRole.name}</h3>
        <Tooltip title={keyPersonRole.description} className={styles.helpIcon}>
          <div>
            <RiQuestionLine size={20} />
          </div>
        </Tooltip>
      </div>

      <p className={styles.completionNotificationText}>
        {keyPersonRole.name === 'Representative' ? (
          <>
            {t('tabs.organization.key_people.roles.requirement_text_representative', {
              amount: keyPersonRole.amount,
            })}
          </>
        ) : (
          <>
            {t('tabs.organization.key_people.roles.requirement_text', {
              amount: keyPersonRole.amount,
            })}
          </>
        )}
      </p>
    </div>
  );
};
